<template>
  <el-select
    v-model="selected"
    size="small"
    @change="handleChange"
    placeholder="选择分类"
    style="width: 100%"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.whole_name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { noticeCategoryList } from '@/service/getData'
import { isMobile } from '@/util/index'

export default {
  props: {
    val: '',
  },
  watch: {
    val: function (v) {
      if (!v) {
        this.selected = ''
      } else {
        this.selected = v
      }
    },
  },
  data() {
    return {
      isMobile,
      selected: '',
      lists: [],
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange() {
      this.$emit('change', this.selected)
    },
    async requestData() {
      let res = await noticeCategoryList({ status: 1 })
      if (res.code == 0) {
        this.lists = res.data.list || []
        if (this.val) {
          this.selected = this.val
        }
      }
    },
  },
}
</script>